const scrollTo = () => {

    document.querySelectorAll('a[href^="#"]').forEach(link => {

        link.addEventListener('click', function(e) {
            e.preventDefault();

            let href = this.getAttribute('href').substring(1);

            if ( href ) {
                const scrollTarget = document.getElementById(href);

                const topOffset = 130;
                const elementPosition = scrollTarget.getBoundingClientRect().top;
                const offsetPosition = elementPosition - topOffset;

                window.scrollBy({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        });
    });

}

export default scrollTo;